import { CheckCircle, Unpublished } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkConfirm from "components/SkComfirm";
import SkLoading from "components/SkLoading";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import { updateOrderDetails } from "redux/festures/orderSlice";
import { getAllOrders } from "redux/festures/orderSlice";
import { handleSingleOrderEmpty } from "redux/festures/orderSlice";
import { getSingleOrders } from "redux/festures/orderSlice";
import { getSingleUser } from "redux/festures/userSlice";
import { SkPrice } from "Utils/dateFunc";
import { SkDate } from "Utils/dateFunc";
import { camelToFlat } from "Utils/dateFunc";
import { formattedDateServer } from "Utils/dateFunc";

const mapStatusByName = {
  PENDING: "PENDING",
  ORDERED: "ORDERED",
  ACCEPTED: "ACCEPTED",
  ONTHEWAY: "ON THE WAY",
  WORKING: "WORKING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  OUT_OF_DELIVERY: "OUT FOR DELIVERY",
  DELIVERED: "DELIVERED",
  RETURN_REQUEST: "RETURN REQUEST",
  RETURNED: "RETURNED",
  RETURN_REQUEST_APPROVED: "RETURN REQUEST APPROVED",
  CANCELLED: "CANCELLED",
  SHIPPED: "SHIPPED",
  MULTI_STATUS: "MULTI STATUS",
  UPCOMING: "UPCOMING",
};

const SingleOrderDetails = ({
  viewOrderId,
  setViewProductModal,
  isFindStatus,
  isOrder,
  setIsOrder,
  handleMenuOpen,
  setIsOpenDialog2,
  isOpenDialog2,
  setSingleOrder,
  singleOrder,
  ecom,
  refreshOrders,
}) => {
  const dispatch = useDispatch();
  const { singleOrders: rawSingleOrders, IsLoading } = useSelector((state) => ({ ...state.isOrders }));
  const adminId = localStorage.getItem("admin_id");

  // Handle array response if returned by ecom filter API
  const singleOrders = ecom && Array.isArray(rawSingleOrders)
    ? rawSingleOrders.find(item => item._id === viewOrderId)
    : (Array.isArray(rawSingleOrders) ? rawSingleOrders[0] : rawSingleOrders);

  
  

  useEffect(() => {
    dispatch(
      getSingleOrders(
        ecom
          ? `/eCommerce/getByOrderId/${viewOrderId}/${adminId}`
          : `/get-booking/${viewOrderId}/${adminId}`
      )

    );
  }, [viewOrderId]);
  useEffect(() => {
    return () => dispatch(handleSingleOrderEmpty(null));
  }, []);

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const [isOrderDetails, setIsOrderDetails] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isIndex, setIsIndex] = useState(0);
  const handleOpenMenu = ({ event }) => {
    setOpenMenu(event.currentTarget);
  };

  

  ;
  const isStatusUpdateFunction = (isStatus) => {
    const status = ecom ? { status: isStatus } : { bookingStatus: isStatus };
    ;
    if (ecom ? (isOrderDetails && isOrderDetails?._id) : (singleOrders && singleOrders?._id)) {
      dispatch(
        updateOrderDetails({
          url: ecom
            ? `${process.env.REACT_APP_APII}/eCommerce/updateSingleStatus/${singleOrders?._id}/${admin}?productId=${isOrderDetails?.productId?._id || isOrderDetails?.productId}`
            : `/update-booking-status/${singleOrders?._id}/${admin}`,
          data: status,
          method: ecom ? "put" : "patch",
        })
      ).then((data) => {
        ;
        dispatch(
          handleAlert({
            isOpen: true,
            type: `${data?.payload?.success ? "success" : "error"}`,
            msg: `${data?.payload?.message}`,
          })
        );
        if (data?.payload?.success) {
          dispatch(
            getSingleOrders(
              ecom
                ? `/eCommerce/getByOrderId/${viewOrderId}/${admin}`
                : `/get-booking/${viewOrderId}/${admin}`
            )
          );
          refreshOrders && refreshOrders();
        }
      });
    } else {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "warning",
          msg: "try again !",
        })
      );
    }
  };
  return IsLoading || !singleOrders ? (
    <SkLoading />
  ) : (
    <>
      <MDBox textAlign="center">
        {singleOrders?.userId || singleOrders?.customerId ? (
          <>
            <MDTypography fontWeight={"medium"} fontSize={20} variant="button">
              Customer Details
            </MDTypography>
            <MDBox
              sx={({ palette: { dark, white, info } }) => ({
                border: 0.5,
                borderColor: darkMode ? white.main : dark.main,
                borderRadius: 3,
                p: 2,
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 2,
              })}
            >
              {/* Removed Customer Image */}
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("_id")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.userId?._id || singleOrders?.customerId?._id}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Full Name")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.userId?.fullName || singleOrders?.customerId?.fullName}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Phone Number")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.userId?.phoneNumber || singleOrders?.address?.mobile || "N/A"}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("User Type")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.userId?.userType?.join(", ") ||
                    singleOrders?.customerId?.userType?.join(", ") ||
                    "N/A"}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Permissions")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.userId?.permissions?.join(", ") ||
                    singleOrders?.customerId?.permissions?.join(", ") ||
                    "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        ) : null}
        {singleOrders?.partnerId ? (
          <>
            <MDTypography fontWeight={"medium"} fontSize={20} variant="button">
              Partner Details
            </MDTypography>
            <MDBox
              sx={({ palette: { dark, white, info } }) => ({
                border: 0.5,
                borderColor: darkMode ? white.main : dark.main,
                borderRadius: 3,
                p: 2,
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 2,
              })}
            >
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30vw",
                  height: "30vh",
                  // gap: 3,
                  [breakpoints.up("xs")]: {
                    // px: 1,
                    width: "90%",
                  },
                  [breakpoints.up("sm")]: {
                    // px: 1,
                    width: "90%",
                  },
                  [breakpoints.up("md")]: {
                    // px: 6,
                    width: "50%",
                  },
                  [breakpoints.up("lg")]: {
                    // px: 6,
                    width: "16vw",
                  },
                })}
              >
                <MDBox width="100%" height="100%" borderRadius="50%">
                  <img
                    src={`${process.env.REACT_APP_URI}/${singleOrders?.partnerId?.image}`}
                    onError={(e) => {
                      (e.onError = null),
                        (e.target.src = require("../../assets/images/bg-profile.png"));
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "fill",
                      borderRadius: "50%",
                    }}
                  />
                </MDBox>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("_id")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.partnerId?._id}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Full Name")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.partnerId?.fullName}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Phone Number")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.partnerId?.phoneNumber}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("User Type")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.partnerId?.userType?.join(", ") || "N/A"}
                </MDTypography>
              </MDBox>
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  borderBottom: "2px",
                  borderColor: darkMode ? white.main : dark.main,
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  gap: 2,
                  [breakpoints.up("xs")]: {
                    px: 1,
                  },
                  [breakpoints.up("sm")]: {
                    px: 1,
                  },
                  [breakpoints.up("md")]: {
                    px: 6,
                  },
                  [breakpoints.up("lg")]: {
                    px: 6,
                  },
                })}
              >
                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    minWidth: "180px",
                    whiteSpace: "nowrap",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {camelToFlat("Permissions")} :
                </MDTypography>

                <MDTypography
                  fontWeight={"medium"}
                  textAlign="left"
                  variant="button"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    fontSize: {
                      xs: "0.5rem",
                      sm: "0.8rem",
                      md: "1.1rem",
                    },
                  }}
                >
                  {singleOrders?.partnerId?.permissions?.join(", ") || "N/A"}
                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        ) : null}
        {singleOrders?.serviceLocation || singleOrders?.address ? (
          <>
            <MDTypography fontWeight={"medium"} fontSize={20} variant="button">
              Address
            </MDTypography>
            <MDBox
              sx={({ palette: { dark, white, info } }) => ({
                border: 0.5,
                borderColor: darkMode ? white.main : dark.main,
                borderRadius: 3,
                p: 2,
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 2,
              })}
            >
              {Object.entries(singleOrders?.serviceLocation || singleOrders?.address).map(([key, value], index) =>
                key === "_id" ||
                  key === "createdAt" ||
                  key === "updatedAt" ||
                  key === "__v" ? null : (
                  <MDBox
                    key={index}
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      borderBottom: "2px",
                      borderColor: darkMode ? white.main : dark.main,
                      borderRadius: 3,
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      width: "100%",
                      gap: 2,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDTypography
                      fontWeight={"medium"}
                      textAlign="left"
                      variant="button"
                      sx={{
                        minWidth: "180px",
                        whiteSpace: "nowrap",
                        fontSize: {
                          xs: "0.5rem",
                          sm: "0.8rem",
                          md: "1.1rem",
                        },
                      }}
                    >
                      {camelToFlat(key)} :
                    </MDTypography>

                    <MDTypography
                      fontWeight={"medium"}
                      textAlign="left"
                      variant="button"
                      sx={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        fontSize: {
                          xs: "0.5rem",
                          sm: "0.8rem",
                          md: "1.1rem",
                        },
                      }}
                    >
                      {value}
                    </MDTypography>
                  </MDBox>
                )
              )}
            </MDBox>
          </>
        ) : null}
        <MDBox
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 1,
            mt: 2,
          }}
        >
          <MDTypography fontWeight={"medium"} fontSize={20} variant="button">
            Order Status :{" "}
            <span
              style={{
                fontSize: "12px",
                fontWeight: 600,
                border: "0.5px solid",
                padding: "5px 8px",
                borderRadius: "5px",
              }}
            >
              {singleOrders?.status ? mapStatusByName[singleOrders?.status] : (singleOrders?.bookingStatus ? mapStatusByName[singleOrders?.bookingStatus] : "N/A")}
            </span>
          </MDTypography>

          <Tooltip title={singleOrders?.bookingStatus || "N/A"}>
            <IconButton
              aria-controls="notification-menu"
              disabled={
                ecom
                  ? (singleOrders?.status === "PENDING" ||
                    singleOrders?.status === "CANCELLED" ||
                    singleOrders?.status === "DELIVERED" ||
                    singleOrders?.status === "RETURN_REQUEST" ||
                    singleOrders?.status === "RETURN_REQUEST_APPROVED" ||
                    singleOrders?.status === "MULTI_STATUS" ||
                    singleOrders?.status === "RETURNED" ||
                    singleOrders?.bookingStatus === "PENDING" ||
                    singleOrders?.bookingStatus === "CANCELLED" ||
                    singleOrders?.bookingStatus === "DELIVERED" ||
                    singleOrders?.bookingStatus === "RETURN_REQUEST" ||
                    singleOrders?.bookingStatus === "RETURN_REQUEST_APPROVED" ||
                    singleOrders?.bookingStatus === "MULTI_STATUS" ||
                    singleOrders?.bookingStatus === "RETURNED")
                  : (singleOrders?.bookingStatus === "CANCELLED" ||
                    singleOrders?.bookingStatus === "COMPLETED")
              }
              aria-haspopup="true"
              component="a"
              target="_blank"
              rel="noreferrer"
              variant="text"
              color="inherit"
              size="small"
              circular
              onClick={(e) => {
                handleMenuOpen({ event: e });
                setIsOrder(singleOrders);
                setSingleOrder(true);
              }}
            >
              <MDBadge
                badgeContent="Update All Order Status"
                color="info"
                variant="gradient"
                size="lg"
              />
            </IconButton>
          </Tooltip>
          <MDBox
            sx={({ palette: { dark, white, info } }) => ({
              border: 0.5,
              borderColor: darkMode ? white.main : dark.main,
              borderRadius: 3,
              p: 2,
              width: "100%",
              height: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 2,
            })}
          >
            {singleOrders?.product &&
              singleOrders?.product.length > 0 &&
              singleOrders?.product.map((value, index) => (
                <MDBox
                  key={index}
                  sx={({ palette: { dark, white, info } }) => ({
                    border: 0.5,
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    p: 1,
                    width: "100%",
                    height: "15rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                  })}
                >
                  <MDBox
                    sx={({ palette: { dark, white, info }, breakpoints }) => ({
                      display: "flex",
                      alignItems: "flex-start",
                      width: "50%",
                      height: "100%",
                      gap: 3,
                      [breakpoints.up("xs")]: {
                        px: 1,
                      },
                      [breakpoints.up("sm")]: {
                        px: 1,
                      },
                      [breakpoints.up("md")]: {
                        px: 6,
                      },
                      [breakpoints.up("lg")]: {
                        px: 6,
                      },
                    })}
                  >
                    <MDBox width="100%" height="100%">
                      <img
                        style={{ width: "80%", height: "100%", p: 1, objectFit: "contain" }}
                        src={`${process.env.REACT_APP_URI}/${value?.productId?.thumnail}`}
                        onError={(e) => {
                          (e.onError = null),
                            (e.target.src = require("../../assets/images/bg-profile.png"));
                        }}
                      />
                    </MDBox>
                  </MDBox>
                  <MDBox width="50%" display="flex" flexDirection="column" alignItems="flex-end">
                    <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                        gap: 3,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <MDTypography
                        variant="h6"
                        sx={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                        }}
                      >
                        {value?.productId?.title || "N/A"}{" "}
                      </MDTypography>
                    </MDBox>
                    {(value?.selectedColor?.name || value?.selectedColor?.code) && (
                      <MDBox
                        sx={({ palette: { dark, white, info }, breakpoints }) => ({
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          gap: 1.5,
                          [breakpoints.up("xs")]: { px: 1 },
                          [breakpoints.up("md")]: { px: 6 },
                        })}
                      >
                        <MDTypography variant="h6">Color Shade :</MDTypography>
                        <MDBox
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 0.5,
                            borderRadius: "20px",
                            backgroundColor: darkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)",
                            border: "1px solid",
                            borderColor: darkMode ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.12)",
                          }}
                        >
                          {value?.selectedColor?.hex && (
                            <span
                              style={{
                                display: "inline-block",
                                width: 14,
                                height: 14,
                                borderRadius: "50%",
                                backgroundColor: value.selectedColor.hex,
                                border: "1px solid rgba(0,0,0,0.2)",
                              }}
                            />
                          )}
                          <MDTypography variant="button" fontWeight="bold">
                            {value?.selectedColor?.name || "Custom Shade"}{" "}
                            {value?.selectedColor?.code && `(${value.selectedColor.code})`}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    )}
                    <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                        gap: 3,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <MDTypography
                        variant="h6"
                        sx={{ fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}
                      >
                        {value?.price?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        }) || "N/A"}
                      </MDTypography>
                    </MDBox>

                    <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                        gap: 3,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <MDTypography variant="h6">Quantity :</MDTypography>
                      <MDTypography
                        variant="h6"
                        sx={{
                          overflow: "hidden",
                          whiteSpace: "wrap",
                          textOverflow: "ellipsis",
                          maxWidth: "70%",
                        }}
                      >
                        {value?.quantity || "N/A"}
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                        gap: 3,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <MDTypography variant="h6">Id :</MDTypography>
                      <MDTypography variant="h6">{value?.productId?._id || "N/A"}</MDTypography>
                    </MDBox>
                    {value?.status && (
                      <MDBox
                        sx={({ palette: { dark, white, info }, breakpoints }) => ({
                          display: "flex",
                          alignItems: "flex-start",
                          width: "100%",
                          gap: 3,
                          [breakpoints.up("xs")]: {
                            px: 1,
                          },
                          [breakpoints.up("sm")]: {
                            px: 1,
                          },
                          [breakpoints.up("md")]: {
                            px: 6,
                          },
                          [breakpoints.up("lg")]: {
                            px: 6,
                          },
                        })}
                      >
                        <MDTypography variant="h6">Status :</MDTypography>

                        <MDBadge
                          badgeContent={value?.status ? mapStatusByName[value?.status] : (value?.bookingStatus ? mapStatusByName[value?.bookingStatus] : "N/A")}
                          color={
                            ((value?.status === "DELIVERED" || value?.bookingStatus === "DELIVERED") && "success") ||
                            ((value?.status === "CANCELLED" || value?.bookingStatus === "CANCELLED") && "error") ||
                            ((value?.status === "OUT_OF_DELIVERY" || value?.bookingStatus === "OUT_OF_DELIVERY") && "info") ||
                            ((value?.status === "RETURNED" || value?.bookingStatus === "RETURNED") && "error") ||
                            ((value?.status === "RETURN_REQUEST" || value?.bookingStatus === "RETURN_REQUEST") && "warning") ||
                            ((value?.status === "RETURN_REQUEST_APPROVED" || value?.bookingStatus === "RETURN_REQUEST_APPROVED") && "info") ||
                            ((value?.status === "ACCEPTED" || value?.bookingStatus === "ACCEPTED") && "success") ||
                            ((value?.status === "PENDING" || value?.bookingStatus === "PENDING") && "warning") ||
                            ((value?.status === "ORDERED" || value?.bookingStatus === "ORDERED") && "primary") ||
                            ((value?.status === "ONTHEWAY" || value?.bookingStatus === "ONTHEWAY") && "info") ||
                            ((value?.status === "WORKING" || value?.bookingStatus === "WORKING") && "secondary") ||
                            ((value?.status === "COMPLETED" || value?.bookingStatus === "COMPLETED") && "success") ||
                            ((value?.status === "SHIPPED" || value?.bookingStatus === "SHIPPED") && "secondary") ||
                            ((value?.status === "MULTI_STATUS" || value?.bookingStatus === "MULTI_STATUS") && "warning") ||
                            ((value?.status === "UPCOMING" || value?.bookingStatus === "UPCOMING") && "primary")
                          }
                          variant="gradient"
                          size="lg"
                        />
                      </MDBox>
                    )}

                    <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        width: "100%",
                        gap: 3,
                        my: 2,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <Tooltip title={value?.bookingStatus || value?.status || "N/A"}>
                        <MDButton
                          variant="contained"
                          color="primary"
                          id="notification-menu2"
                          onClick={(e) => {
                            handleOpenMenu({ event: e });
                            setIsOrderDetails(value);
                            setIsOrder(value); // Set parent state
                            setIsIndex(index);
                            setSingleOrder(false); // Mode is single status
                          }}
                        >
                          Change Status
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                    {/* <MDBox
                      sx={({ palette: { dark, white, info }, breakpoints }) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: 3,
                        [breakpoints.up("xs")]: {
                          px: 1,
                        },
                        [breakpoints.up("sm")]: {
                          px: 1,
                        },
                        [breakpoints.up("md")]: {
                          px: 6,
                        },
                        [breakpoints.up("lg")]: {
                          px: 6,
                        },
                      })}
                    >
                      <MDTypography variant="h6">Ordered Last Update At :</MDTypography>
                      <MDTypography
                        variant="h6"
                        sx={{
                          overflow: "hidden",
                          whiteSpace: "wrap",
                          textOverflow: "ellipsis",
                          maxWidth: "70%",
                        }}
                      >
                        {SkDate(new Date(value?.updatedAt))}{" "}
                      </MDTypography>
                    </MDBox> */}
                  </MDBox>
                </MDBox>
              ))}
          </MDBox>
        </MDBox>
        {null}
        {singleOrders && (

          <>
            <MDTypography fontWeight={"medium"} fontSize={20} variant="button">
              Order &apos;s details
            </MDTypography>
            <MDBox
              sx={({ palette: { dark, white, info } }) => ({
                border: 0.5,
                borderColor: darkMode ? white.main : dark.main,
                borderRadius: 3,
                p: 2,
                width: "100%",
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 2,
              })}
            >
              
              {null}
              <MDBox sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>

                {/* Order ID */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Order ID :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>{singleOrders?._id || "N/A"}</MDTypography>
                </MDBox>

                {/* Customer Email */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Customer Email :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.userId?.email || singleOrders?.address?.email || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Phone Number */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Phone :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.userId?.phoneNumber || singleOrders?.address?.mobile || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Service Name */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Service :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.subCategoryId?.name || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Address */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Service Address :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.serviceLocation?.address || singleOrders?.address?.address || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Floors */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>No. of Floors :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.numberOfFloors || 0}
                  </MDTypography>
                </MDBox>

                {/* Price Per Floor */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Price / Floor :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    ₹ {singleOrders?.pricePerFloor || 0}
                  </MDTypography>
                </MDBox>

                {/* Total Amount */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Total Amount :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {SkPrice(singleOrders?.totalAmount || 0)}
                  </MDTypography>
                </MDBox>

                {/* Tax */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Tax :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    ₹ {singleOrders?.taxAmount || 0} ({singleOrders?.taxPercent}%)
                  </MDTypography>
                </MDBox>

                {/* Final Payable */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Final Payable :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    ₹ {singleOrders?.finalPayableAmount || singleOrders?.netAmount || 0}
                  </MDTypography>
                </MDBox>

                {/* Service Date */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Service Date :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.serviceDate ? new Date(singleOrders?.serviceDate).toDateString() : (singleOrders?.createdAt ? new Date(singleOrders?.createdAt).toDateString() : "N/A")}
                  </MDTypography>
                </MDBox>

                {/* Time Slot */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Time Slot :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.serviceTimeSlot || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Booking Status */}
                <MDBox display="flex" justifyContent="flex-start" gap={2} alignItems="center">
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Booking Status :</MDTypography>
                  <MDBox display="flex" alignItems="center" gap={2}>
                    <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>{singleOrders?.bookingStatus || "N/A"}</MDTypography>
                    <MDButton
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={(e) => {
                        handleMenuOpen({ event: e });
                        setIsOrder(singleOrders);
                        setSingleOrder(true);
                      }}
                    >
                      Change Status
                    </MDButton>
                  </MDBox>
                </MDBox>

                {/* Payment Status */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Payment Status :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.paymentStatus || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Payment Method */}
                <MDBox display="flex" justifyContent="flex-start" gap={2}>
                  <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Payment Method :</MDTypography>
                  <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>
                    {singleOrders?.paymentMethod || "N/A"}
                  </MDTypography>
                </MDBox>

                {/* Transaction Id */}
                {singleOrders?.transactionId && (
                  <MDBox display="flex" justifyContent="flex-start" gap={2}>
                    <MDTypography fontWeight="medium" sx={{ minWidth: "180px", whiteSpace: "nowrap", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>Transaction Id :</MDTypography>
                    <MDTypography sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" } }}>{singleOrders?.transactionId || "N/A"}</MDTypography>
                  </MDBox>
                )}

              </MDBox>

              {singleOrders?.date && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    Working Date :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {formattedDateServer(new Date(singleOrders?.date)) || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.time && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    Working time :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {singleOrders?.time || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.remark && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    Remark :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {singleOrders?.remark || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.sparePartsAmount && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {camelToFlat("sparePartsAmount")} :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {SkPrice(singleOrders?.sparePartsAmount || 0) || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.transportAmount && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {camelToFlat("transportAmount")} :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {SkPrice(singleOrders?.transportAmount || 0) || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.courierAmount && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {camelToFlat("courierAmount")} :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {SkPrice(singleOrders?.courierAmount || 0) || "N/A"}
                  </MDTypography>
                </MDBox>
              )}
              {singleOrders?.invoice && (
                <MDBox
                  // key={index}
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    borderBottom: "2px",
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: "100%",
                    gap: 2,
                    [breakpoints.up("xs")]: {
                      px: 1,
                    },
                    [breakpoints.up("sm")]: {
                      px: 1,
                    },
                    [breakpoints.up("md")]: {
                      px: 6,
                    },
                    [breakpoints.up("lg")]: {
                      px: 6,
                    },
                  })}
                >
                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      minWidth: "180px",
                      whiteSpace: "nowrap",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    {camelToFlat("invoiceDownload")} :
                  </MDTypography>

                  <MDTypography
                    fontWeight={"medium"}
                    textAlign="left"
                    variant="button"
                    sx={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      fontSize: { xs: "0.5rem", sm: "0.8rem", md: "1.1rem" },
                    }}
                  >
                    <MDButton
                      type={"button"}
                      variant="contained"
                      color="info"
                      onClick={() =>
                        window.open(`${process.env.REACT_APP_URI}/${singleOrders?.invoice}`)
                      }
                    >
                      invoice
                    </MDButton>
                    {/* {singleOrders?.transactionId || "N/A"} */}
                  </MDTypography>
                </MDBox>
              )}
            </MDBox>

            {singleOrders?.afterWorkingImage && singleOrders?.afterWorkingImage?.at(0) && (
              <>
                <MDTypography fontWeight={"medium"} textAlign="left" fontSize={15} variant="button">
                  {camelToFlat(" afterWorkingImage")}
                </MDTypography>{" "}
                <MDBox
                  sx={({ palette: { dark, white, info } }) => ({
                    border: 0.5,
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    p: 2,
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    alignContent: "flex-start",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 2.5,
                    color: "#fff",
                  })}
                >
                  {singleOrders?.afterWorkingImage &&
                    singleOrders?.afterWorkingImage?.at(0) &&
                    singleOrders?.afterWorkingImage?.map((img, index) => (
                      <MDBox
                        key={index}
                        sx={{
                          maxWidth: "30%",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_URI}/${img}`}
                          onError={(e) => {
                            (e.onError = null),
                              (e.target.src = require("../../assets/images/bg-profile.png"));
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "12px",
                            objectFit: "contain",
                          }}
                        />
                      </MDBox>
                    ))}
                </MDBox>
              </>
            )}
            {singleOrders?.beforeWorkingImage && singleOrders?.beforeWorkingImage?.at(0) && (
              <>
                <MDTypography fontWeight={"medium"} textAlign="left" fontSize={15} variant="button">
                  {camelToFlat(" beforeWorkingImage")}
                </MDTypography>{" "}
                <MDBox
                  sx={({ palette: { dark, white, info } }) => ({
                    border: 0.5,
                    borderColor: darkMode ? white.main : dark.main,
                    borderRadius: 3,
                    p: 2,
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    alignContent: "flex-start",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 2.5,
                    color: "#fff",
                  })}
                >
                  {singleOrders?.beforeWorkingImage &&
                    singleOrders?.beforeWorkingImage?.at(0) &&
                    singleOrders?.beforeWorkingImage?.map((img, index) => (
                      <MDBox
                        key={index}
                        sx={{
                          maxWidth: "30%",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_URI}/${img}`}
                          onError={(e) => {
                            (e.onError = null),
                              (e.target.src = require("../../assets/images/bg-profile.png"));
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "12px",
                          }}
                        />
                      </MDBox>
                    ))}
                </MDBox>
              </>
            )}
          </>
        )}
      </MDBox>

      <Menu
        anchorEl={openMenu}
        anchorReference={null}
        aria-controls="notification-menu2"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(openMenu)}
        onClose={() => setOpenMenu(false)}
      >
        {/* <MenuItem sx={{ border: "1px solid blue", mb: 1 }}>fhfghfbx</MenuItem> */}
        {singleOrders?.product?.length > 0 &&
          isIndex !== undefined &&
          singleOrders?.product?.[isIndex]?.status === "PENDING" && (
            <>

              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("ORDERED");
                }}
              >
                <MDAvatar size="sm">
                  <CheckCircle />
                </MDAvatar>{" "}
                APPROVED
              </MenuItem>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CANCELLED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                REJECTED
              </MenuItem>
            </>
          )}
        {singleOrders?.product?.length > 0 &&
          singleOrders?.product?.[isIndex]?.status === "ORDERED" && (

            <>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CONFIRMED");
                }}
              >
                <MDAvatar size="sm">
                  <CheckCircle />
                </MDAvatar>{" "}
                CONFIRMED
              </MenuItem>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CANCELLED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                REJECTED
              </MenuItem>
            </>
          )}
        {singleOrders?.product?.length > 0 &&
          singleOrders?.product?.[isIndex]?.status === "CONFIRMED" && (

            <>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("SHIPPED");
                }}
              >
                <MDAvatar size="sm">
                  <CheckCircle />
                </MDAvatar>{" "}
                SHIPPED
              </MenuItem>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CANCELLED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                REJECTED
              </MenuItem>
            </>
          )}
        {singleOrders?.product?.length > 0 &&
          singleOrders?.product?.[isIndex]?.status === "SHIPPED" && (

            <>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("OUT FOR DELIVERY");
                }}
              >
                <MDAvatar size="sm">
                  <CheckCircle />
                </MDAvatar>{" "}
                OUT FOR DELIVERY
              </MenuItem>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CANCELLED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished Tooltip={"REJECTED"} sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                REJECTED
              </MenuItem>
            </>
          )}
        {singleOrders?.product?.length > 0 &&
          singleOrders?.product?.[isIndex]?.status === "OUT FOR DELIVERY" && (

            <>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("DELIVERED");
                }}
              >
                <MDAvatar size="sm">
                  <CheckCircle />
                </MDAvatar>{" "}
                DELIVERED
              </MenuItem>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("CANCELLED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                REJECTED
              </MenuItem>
            </>
          )}
        {singleOrders?.product?.length > 0 &&
          isIndex !== undefined &&
          singleOrders?.product?.[isIndex]?.status === "RETURN_REQUEST_APPROVED" && (

            <>
              <MenuItem
                sx={{ border: "1px solid blue", mb: 1 }}
                onClick={() => {
                  setOpenMenu(false);
                  isStatusUpdateFunction("RETURNED");
                }}
              >
                <MDAvatar size="sm">
                  <Unpublished sx={{ fontSize: "2rem" }} />
                </MDAvatar>
                RETURNED
              </MenuItem>
            </>
          )}
        {!ecom && (singleOrders?.bookingStatus === "PENDING" || singleOrders?.status === "PENDING") && (
          <>
            <MenuItem
              sx={{ border: "1px solid blue", mb: 1 }}
              onClick={() => {
                setOpenMenu(false);
                isStatusUpdateFunction("UPCOMING");
              }}
            >
              UPCOMING
            </MenuItem>
            <MenuItem
              sx={{ border: "1px solid blue", mb: 1 }}
              onClick={() => {
                setOpenMenu(false);
                isStatusUpdateFunction("CANCELLED");
              }}
            >
              CANCEL
            </MenuItem>
          </>
        )}
        {!ecom && (singleOrders?.bookingStatus === "UPCOMING" || singleOrders?.status === "UPCOMING") && (
          <>
            <MenuItem
              sx={{ border: "1px solid blue", mb: 1 }}
              onClick={() => {
                setOpenMenu(false);
                isStatusUpdateFunction("COMPLETED");
              }}
            >
              COMPLETED
            </MenuItem>
            <MenuItem
              sx={{ border: "1px solid blue", mb: 1 }}
              onClick={() => {
                setOpenMenu(false);
                isStatusUpdateFunction("CANCELLED");
              }}
            >
              CANCEL
            </MenuItem>
          </>
        )}
      </Menu>

      <SkConfirm
        dialogTitle={"Order Cancel"}
        dialogContent={"Are you sure you want to Cancel this Order?"}
        open={isOpenDialog2}
        setOpen={setIsOpenDialog2}
        rate={true}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,

              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => {
                setIsOpenDialog2((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color="error"
              onClick={() => {
                isStatusUpdateFunction("CANCELLED", true);

                setIsOpenDialog2((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              yes
            </MDButton>
          </MDBox>
        }
      />
    </>
  );
};

export default SingleOrderDetails;
SingleOrderDetails.propTypes = {
  //   children: PropTypes.node,
  viewOrderId: PropTypes.any,
  setViewProductModal: PropTypes.any,
  isFindStatus: PropTypes.any,
  isOrder: PropTypes.any,
  setIsOrder: PropTypes.any,
  handleMenuOpen: PropTypes.any,
  setIsOpenDialog2: PropTypes.any,
  isOpenDialog2: PropTypes.any,
  singleOrder: PropTypes.any,
  setSingleOrder: PropTypes.func,
  ecom: PropTypes.bool,
  refreshOrders: PropTypes.func,
};
